import type { Transaction } from '@popety-io/types'

export const getSavedTransactionLocation = (
  transaction: Transaction
): string => {
  const properties = transaction.transaction_properties || []
  const address = properties
    .map((property) => property.land_address?.trim())
    .find(Boolean)

  if (address) return address

  const property = properties.find(
    ({ npa_name: postalCode, city_name: city }) => postalCode || city
  )
  if (!property) return '—'

  return (
    [property.npa_name, property.city_name].filter(Boolean).join(', ') || '—'
  )
}
